export default "__VITE_ASSET__vG2nBRE___"